<template>
  <div>
    <MenuPromotion/>
    <Promotion_set/>
  </div>
</template>

<script>
import MenuPromotion from "@/components/admin/stock/storage_promotion/menupromotion/MenuPromotion";
import Promotion_set from "@/components/admin/stock/storage_promotion/Promotion_set";
export default {
name: "PromotionSet",
  components: {
    Promotion_set,
    MenuPromotion
  }
}
</script>

<style scoped>

</style>
